module.exports = __webpack_public_path__ + "static/media/signUpBg.3fc0b02f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/components/SignUp/signUpBg.svg
// module id = 930
// module chunks = 0